import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { ReCaptchaComponent, ReCaptchaService } from 'angular-recaptcha3';
import { ButtonComponent } from 'sharedGuiSmall/components';
import { IntegrationCompany, LicensePackageOptions, LicensePackageType, LicenseStatus } from 'sharedGuiSmall/enums';
import { RedirectGlobalService } from 'sharedGuiSmall/sharedServices/redirectGlobal.service';
import { ValidationMessage } from 'sign-up-app/interfaces/ValidationMessage';
import { AuthAppService } from "sign-up-app/services/auth.service";
import { RegisterUser } from "sign-up-app/sign-up/RegisterUser";
import { NavigationSmallUtils } from 'sharedGuiSmall/utils/navigation-utils';
import { TranslateService } from '@ngx-translate/core'

declare var grecaptcha: ReCaptchaComponent;

@Component({
    selector: 'sign-up',
    templateUrl: './sign-up.component.html',
    styleUrls: ['./sign-up.component.less']
})
export class SignUpComponent implements OnInit {

    @ViewChild('emailInput')
    private emailInput!: ElementRef<HTMLInputElement>;

    @ViewChild('confirmEmailInput')
    private confirmEmailInput!: ElementRef<HTMLInputElement>;

    @ViewChild('passwordInput')
    private passwordInput!: ElementRef<HTMLInputElement>;

    @ViewChild('emailWrongMsg')
    private emailWrongMsg!: ElementRef<HTMLDivElement>;

    @ViewChild('confirmEmailWrongMsg')
    private confirmEmailWrongMsg!: ElementRef<HTMLDivElement>;

    @ViewChild('pwdEye')
    private pwdEye!: ElementRef<HTMLElement>;

    @ViewChild('passwordWrongMsg')
    private passwordWrongMsg!: ElementRef<HTMLDivElement>;

    @ViewChild('secondColumn')
    private secondColumn!: ElementRef<HTMLDivElement>;

    @ViewChild('pwdHints')
    private pwdHints!: ElementRef<HTMLDivElement>;

    @ViewChild('signUpBtn')
    private signUpBtn!: ButtonComponent;

    @ViewChild('xeroSignUpBtn')
    private xeroSignUpBtn!: ButtonComponent;

    @ViewChild('crunchSignUpBtn')
    private crunchSignUpBtn?: ButtonComponent;

    @ViewChild('qbSignUpBtn')
    private qbSignUpBtn?: ButtonComponent;

    linkForm: string = 'brixx-start';
    confirmEmailPage: string = 'verification-required';

    returnLinkForm: string = 'sign-up/foundation';
    validateMarkOk = 'validation-ok-mark_sign-up';
    validateMarFail = 'validation-failed-mark_sign-up';

    package: string | undefined = '';
    freq: string | null = '';
    cur: string | null = '';

    licenseType: string = LicensePackageType.BrixxFree

    returnToSignIn: string = 'sign-in'

    newUser = new RegisterUser();
    confirmEmail: string = '';
    password: string = '';

    isEmailValid: boolean = false;
    isConfirmEmailValid: boolean = true;
    isPasswordValid: boolean = false;

    fullLiveUrl = window.fullLiveUrl;

    integrationCompany = IntegrationCompany;
    fullUrl: string = window.fullLiveUrl;
    productVersion: string = '2.0';

    isQBSSO = window.isQBSSO;
    isAppleButtonVisible = window.isAppleButtonVisible;
    isCrunchButtonVisible = window.isCrunchButtonVisible;

    createAccountButtonText = $localize `:@@createAccountBtnText:CREATE_YOUR_ACCOUNT`;
    xeroSignUpButtonText = $localize`:@@xeroSignUpButton:CONTINUE_WITH_XERO`;
    crunchSignUpButtonText = $localize `:@@crunchSignUpButton:CONTINUE_WITH_CRUNCH`;
    quickBooksSignUpButtonText = $localize `:@@quickBooksSignUpButton:Sign up for free with QuickBooks`;
    googleSignUpButtonText = $localize`:@@googleSignUpButton:CONTINUE_WITH_GOOGLE`;
    appleSignUpButtonText = $localize`:@@appleSignUpButton:CONTINUE_WITH_APPLE`;
    facebookSignUpButtonText = $localize`:@@facebookSignUpButton:CONTINUE_WITH_FACEBOOK`;



    emailAddressRequired = $localize`THE_EMAIL_ADDRESS_FIELD`;
    notValidEmail = $localize`NOT_A_VALID_EMAIL`;
    passwordRequired = $localize`THE_PASSWORD_FIELD_MUST`;
    maxEmailLength = $localize`MAXIMUM_EMAIL_LENGTH_100`;
    confirmEmails = $localize`EMAILS_SHOULD_MATCH`;

    minLengthPassword = $localize`MINIMUM_PASSWORD_LENGTH_8`;
    upperCasePassword = $localize`DOES_NOT_MEET_PASSWORD`;
    lowerCasePassword = $localize`DOES_NOT_MEET_PASSWORD`;
    requirementsPassword = $localize`DOES_NOT_MEET_PASSWORD`;
    maxLengthPassword = $localize`MAXIMUM_PASSWORD_LENGTH_48`;

    isBusinessDoctors: boolean = false;

    get isCopyPasteBlocked() {
        return window.isCopyPasteBlocked;
    }
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private authService: AuthAppService,
        private recaptchaService: ReCaptchaService,
        private redirectService: RedirectGlobalService,
        private translate: TranslateService
    ) {
        this.isBusinessDoctors = (String)(window['isBusinessDoctors']).toLowerCase() === 'true';
    }

    ngOnInit(): void {

        this.getPackageType();
        if (this.package != LicensePackageType.Trial) {             
            this.freq = this.frequency;
            this.cur = this.currency;
            let plansCount = this.plansCount;
        }

        const url = window.location.href;

        if (url.indexOf('http_referer=') !== -1) {

            let tokens = url.split('&');
            console.warn('tokens', tokens);

            if (tokens && tokens.length > 1) {
                const position = tokens[1].split('your_role=')[1].replace(/\+/g, " ");
                this.newUser.email = tokens[0].split('email=')[1].replace(/%40/g, "@");

                localStorage.setItem('selectedPositionId', this.newUser.selectedPositionId + '');
                localStorage.setItem('getResponseEmail', this.newUser.email);
                localStorage.setItem('sign-up-position', position);

                window.location.href = this.fullLiveUrl + 'xero-creation';
            }
        }
    }

    ngAfterViewInit() { 
        
    }

    private getNameLicense(packageType: string): void {
        const packageTypeMap = {
            [LicensePackageOptions.get(LicensePackageType.BrixxFree)!.OptionName]: LicensePackageType.BrixxFree
        };

        if (packageType in packageTypeMap) {
            this.licenseType = packageTypeMap[packageType];
        } else if (packageType === LicenseStatus.Trial) {
            this.licenseType = LicenseStatus.Trial;
        }
        else
            this.licenseType = packageType;
    }

    private getFindPackage(packageType: string) {
        packageType = this.toUpperCaseFirstLetter(packageType);

        this.getNameLicense(packageType);

        const licenses = [LicensePackageType.BrixxFree, LicensePackageType.BrixxSingle];

        for (let i = 0; i < licenses.length; i++) {
            if (String(this.licenseType).includes(licenses[i]) && this.licenseType != LicenseStatus.Trial) {
                this.package = LicensePackageOptions.get(licenses[i])!.OptionName;
                break;
            }
            if (this.licenseType == LicenseStatus.Trial) {
                this.package = LicenseStatus.Trial;
                break;
            }
        }

        if (this.package === undefined) {
            this.router.navigate([this.returnLinkForm], { skipLocationChange: false });
        }
    }

    toUpperCaseFirstLetter(pack: string): string {
        return String(pack).charAt(0).toUpperCase() + String(pack.toLowerCase()).slice(1);
    }

    get frequency() { 
        let freq = this.route.snapshot.paramMap.get('frequency');
        if (freq) {
            freq = freq.toLowerCase();
            if (['monthly', 'annually'].indexOf(freq) == -1)
                this.redirectToTrial();

            freq = this.toUpperCaseFirstLetter(freq)
        }

        return freq;
    }

    get currency() {
        let cur = this.route.snapshot.paramMap.get('currency');
        if (cur) {
            if (['gbp', 'usd', 'eur', 'cad', 'aud'].indexOf(cur) == -1)
                this.redirectToTrial();

            cur = cur.toUpperCase()
        }

        return cur;
    }

    get plansCount() { 
        let plansCount = this.route.snapshot.paramMap.get('planscount');

        if (plansCount) {            
            if ([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 15, 20, 30, 40, 50].indexOf(parseInt(plansCount)) == -1)
                this.redirectToTrial();
            
        }

        return plansCount;

    }

    get packageName() { 
        return `${this.package}${this.plansCount}`;
    }

    redirectToTrial() { 
        location.href = '/sign-up';
    }

    getPackageType() {
        let packageType: string | null = this.route.snapshot.paramMap.get('package');
        
        if (packageType == null) {
            packageType = LicensePackageOptions.get(LicensePackageType.BrixxFree)!.OptionName;
        }
        
        this.getFindPackage(packageType);

        if (this.package !== undefined && this.package != '') {
            localStorage.setItem('packageTypeRegistration', LicensePackageOptions.get(this.licenseType)!.OptionName ?? '');

            this.linkForm = (this.licenseType === LicenseStatus.Trial || this.licenseType === LicensePackageType.BrixxFree) ? 'brixx-start' : 'payment-form';
        }
        else
            this.redirectToTrial();
    }

    validateField(validationType: string, value: string, validations: Array<string>, validationMessages: ValidationMessage): boolean {

        let isValid = true;
        switch (validationType) {
            case 'email':
                isValid = this.authService.ValidateField(this.emailInput, this.emailWrongMsg, value, validations, validationMessages, '', this.validateMarkOk, this.validateMarFail); break;
            case 'confirmemail':
                isValid = this.authService.ValidateField(this.confirmEmailInput, this.confirmEmailWrongMsg, value, validations, validationMessages, this.newUser.email, this.validateMarkOk, this.validateMarFail); break;
            case 'password':
                isValid = this.authService.ValidateField(this.passwordInput, this.passwordWrongMsg, value, validations, validationMessages, '', this.validateMarkOk, this.validateMarFail); break;
        }

        return isValid;
    }

    goToSignIn() {
        this.router.navigate([this.returnToSignIn], { skipLocationChange: false });
    }

    toggleGetNews(): void {
        this.newUser.getNews = !this.newUser.getNews;
    }

    onPasswordType() {
        this.authService.ProcessPasswordHints(this.newUser.passwordStr, this.pwdHints, 8);
    }

    onPasswordSwitcher() {
        this.authService.ProcessPasswordSwitcher(this.passwordInput, this.pwdEye);
    }

    validateEmail(): void {
        this.translate.get([this.emailAddressRequired, this.notValidEmail, this.maxEmailLength]).subscribe(translations => {
            this.isEmailValid = this.validateField('email', this.newUser.email, ['required', 'email', 'maxlength 100'],
                {
                    'required': translations[this.emailAddressRequired],
                    'email': translations[this.notValidEmail],
                    'maxlength': translations[this.maxEmailLength]
                });
            if (this.confirmEmail) this.validateConfirmEmail();
        });
    }

    validateConfirmEmail(): void {
        this.translate.get([this.emailAddressRequired, this.notValidEmail, this.confirmEmails, this.maxEmailLength]).subscribe(translations => {
            this.isConfirmEmailValid = this.validateField('confirmemail', this.confirmEmail, ['required', 'email', 'confirmemail', 'maxlength 100'],
                {
                    'required': translations[this.emailAddressRequired],
                    'email': translations[this.notValidEmail],
                    'confirmemail': translations[this.confirmEmails],
                    'maxlength 100': translations[this.maxEmailLength]
                });
            this.isConfirmEmailValid = true;
        });
    }

    validatePassword(): void {
        this.translate.get([this.passwordRequired, this.minLengthPassword, this.upperCasePassword, this.lowerCasePassword, this.requirementsPassword, this.maxLengthPassword]).subscribe(translations => {
            this.isPasswordValid = this.validateField('password', this.newUser.passwordStr, ['required', 'minlength 8', 'uppercase', 'lowercase', 'special', 'maxlength 48'],
                {
                    'required': translations[this.passwordRequired],
                    'minlength': translations[this.minLengthPassword],
                    'uppercase': translations[this.upperCasePassword],
                    'lowercase': translations[this.lowerCasePassword],
                    'special': translations[this.requirementsPassword],
                    'maxlength': translations[this.maxLengthPassword]
                });
        });
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event.key == "Enter")
            this.signUp();
    }

    signUp(): void {

        this.validateEmail();
        this.validateConfirmEmail();
        this.validatePassword();

        if (this.isEmailValid && this.isConfirmEmailValid && this.isPasswordValid) {
            this.recaptchaService.execute();
        }
        else {
            console.error('validation failed');
        }
    }

    integrationSignUp(integrationCompany: IntegrationCompany): void {
        this.checkPaidOnSignup();
        this.redirectService.redirectToIntegrator(integrationCompany, this.newUser.getNews);        
    }
    
    enableBtns(): void {
        this.signUpBtn.getElDom().style.pointerEvents = '';
        this.xeroSignUpBtn.getElDom().style.pointerEvents = '';

        if (this.crunchSignUpBtn)
            this.crunchSignUpBtn.getElDom().style.pointerEvents = '';

        if (this.qbSignUpBtn)
            this.qbSignUpBtn.getElDom().style.pointerEvents = '';
    }

    disableBtns(): void {
        this.signUpBtn.getElDom().style.pointerEvents = 'none';
        this.xeroSignUpBtn.getElDom().style.pointerEvents = 'none';

        if (this.crunchSignUpBtn)
            this.crunchSignUpBtn.getElDom().style.pointerEvents = 'none';

        if (this.qbSignUpBtn)
            this.qbSignUpBtn.getElDom().style.pointerEvents = 'none';
    }

    getBrixxVerificationEmailUrl() {
        return this.fullUrl + 'verification-email';
    }

    getBrixxAccountUrl() {
        return this.fullUrl + 'Account';
    }


    goToPayment(userName: string, userId: number, externalCustomerRef: string) {
        this.authService.getAccountDataMiddleware().then((data) => { 
            if (this.package && this.freq && this.cur) {
                
                data.UserName = userName;
                data.externalCustomerRef = externalCustomerRef;                

                NavigationSmallUtils.openPaymentPage(
                    data,
                    this.packageName,
                    this.freq,
                    this.cur,                    
                    `${this.fullUrl}activate-paid-sign-up/${userId}`,
                    false,
                    this.productVersion,
                    data.subscriptionRef
                );
            }
        });
        
    }

    checkPaidOnSignup() { 
        let result = this.package != LicensePackageType.Trial;        
        document.cookie = `isPaidOnSignup=${result}; path=/`;        
        if (result) 
            document.cookie = `isPaidOnSignupParams=${this.packageName},${this.freq},${this.cur}; path=/`;                    

        return result;
    }

    onCaptchaResponse(token: string): void {
        this.disableBtns();
        this.authService.toggleSpinner();
        this.newUser.captchaText = token;

        this.newUser.password = this.newUser.passwordStr;

        localStorage.setItem("brixx-email", this.newUser.email);        
        this.newUser.isPaidOnSignup = this.checkPaidOnSignup();        

        // use BrixxFree (Foundations) for unfinished signups - todo check the necessity        
        // this.newUser.isFree = this.package != LicenseStatus.Trial;

        const newUser = JSON.stringify(this.newUser);
        this.authService.RegisterUser(newUser).then((res: string) => {
            let data = { newUserId: 0, userHasInvites: false, companyToWhichUserInvited: '', success: false, errorMessage: '', externalCustomerRef: '' };            
            this.enableBtns();
            this.authService.toggleSpinner();
            if (res && res.length) {
                data = JSON.parse(res);
                let externalCustomerRef = data.externalCustomerRef;
                let newUserId = data.newUserId;

                if (data.success && !data.errorMessage) {

                    this.authService.SetupOrganisation(newUserId, this.newUser.email, this.package!, this.newUser.isPaidOnSignup)
                        .then((res) => {
                            let data = { success: false, companyId: '' };
                            data = JSON.parse(res);
                            localStorage.setItem('newUserEmail', this.newUser.email);
                            localStorage.setItem('selectedCompanyId', data.companyId);
                            
                            document.cookie = `selectedCompanyIdForBuy=${data.companyId}; path=/;`;
                            document.cookie = `packageTypeUpgrade#${data.companyId}=${this.packageName}; path=/;`;

                            if (this.newUser.isPaidOnSignup)
                                this.goToPayment(this.newUser.email, newUserId,  externalCustomerRef);                                
                            else
                                document.location.href = this.getBrixxVerificationEmailUrl();
                        });

                } else {
                    if (this.passwordInput && this.passwordWrongMsg) {
                        this.translate.get([data.errorMessage]).subscribe(translations => {
                            this.authService.AddErrorMessage(this.passwordInput, this.passwordWrongMsg, translations[data.errorMessage], this.validateMarkOk, this.validateMarFail);
                        });
                    }
                    grecaptcha.reset();
                }
            }
        }).catch((reason: string) => {
            console.log('RegisterUser error', reason);
            this.enableBtns();
            this.authService.toggleSpinner();

            if (this.passwordInput && this.passwordWrongMsg) {
                this.authService.AddErrorMessage(this.passwordInput, this.passwordWrongMsg, 'Unknown register user server error', this.validateMarkOk, this.validateMarFail);
            }
            grecaptcha.reset();
        });
    }
    
}